import { render, staticRenderFns } from "./DashboardBaner.vue?vue&type=template&id=df06d4c6&scoped=true"
import script from "./DashboardBaner.vue?vue&type=script&lang=js"
export * from "./DashboardBaner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df06d4c6",
  null
  
)

export default component.exports